import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetAdResponseBody } from '../AdsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseAdQueryValues = {
  appId: string;
  adId: string;
};

export const adQueryKeyFactory: IQueryKeyFactory<IUseAdQueryValues> = (
  values,
) => values && (['ads', values.appId, values.adId] as const);

export const useAdQuery = (
  values?: IUseAdQueryValues,
  options?: UseQueryOptions<IApiGetAdResponseBody, ApiError>,
): UseQueryResult<IApiGetAdResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: adQueryKeyFactory(values),
    queryFn: values ? () => api.ads.get(values.appId, values.adId) : undefined,
    ...options,
  });
};
